import gql from "graphql-tag";

const getPlaneacionId = gql`
  query Planning($planningId: ID!) {
    planning(id: $planningId) {
      id
      name
      initial_date
      end_date
      institution {
        id
      }
      isActive
      perspectives {
        id
        name
        description
      }
      philosophies {
        id
        description
        name
      }
      responsible {
        id
        name
        first_surname
        isValidator
        area {
          id
          name
        }
      }
      signals {
        color
        id
        operator_00
        value_00
        value_01
      }
      enableMailReports
      business_days
      status
    }
  }
`;


const getPlaneaciones = gql`
  query Planning($args: FilterParamsInput) {
    searchPlannings(args: $args) {
      data {
        id
        name
        initial_date
        end_date
        business_days
        isActive
        status
        report_intro
        enableMailReports
        report_attachment
        report_emails
        institutionId
        institution {
          id
        }
        responsible {
          area {
            id
          }
          id
        }
        signals {
          id
          color
          description
          operator_00
          value_00
          value_01
        }
      }
      metadata {
        hasNextPage
      }
    }
  }
`;

const getPlaneacionesMenu = gql`
  query Planning($args: FilterParamsInput) {
    searchPlannings(args: $args) {
      data {
        id
        name
        institution {
          id
        }
      }
      metadata {
        hasNextPage
      }
    }
  }
`;

export { getPlaneacionId, getPlaneaciones, getPlaneacionesMenu }